import { DocumentNode, gql } from '@apollo/client'

export const GET_SUGGEST_SETTINGS: DocumentNode = gql`
    query GetSuggestSettings($daycareId: Int!) {
        getSuggestSettings(daycareId: $daycareId) {
            staffDistance
            parentDistance
            parentMinMonth
            parentMaxMonth
            contactEmails
            notification
        }
    }
`

export const SET_STAFF_SUGGEST_SETTINGS: DocumentNode = gql`
    mutation SetStaffSuggestSettings($daycareId: Int!, $distance: SuggestStaffDistance!) {
        setStaffSuggestSettings(daycareId: $daycareId, distance: $distance)
    }
`

export const SET_PARENT_SUGGEST_SETTINGS: DocumentNode = gql`
    mutation SetParentSuggestSettings(
        $daycareId: Int!
        $distance: SuggestParentDistance!
        $minMonth: Int!
        $maxMonth: Int!
    ) {
        setParentSuggestSettings(daycareId: $daycareId, distance: $distance, minMonth: $minMonth, maxMonth: $maxMonth)
    }
`

export const SET_NOTIFICATION_SUGGEST_SETTINGS: DocumentNode = gql`
    mutation SetNotificationSuggestSettings($daycareId: Int!, $contactEmails: [String]!, $notification: Boolean!) {
        setNotificationSuggestSettings(
            daycareId: $daycareId
            contactEmails: $contactEmails
            notification: $notification
        )
    }
`
